import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { GpdPillComponent } from "../gpd-pill/gpd-pill.component";
import { TaskTag } from "src/app/interfaces/entities/task-tag";

/**
 * Read-only task tags in the contacts tag style (#4752). Shows up to `max` pills followed by a
 * plain "+N" link; clicking it expands the cell to all tags, "weniger anzeigen" collapses it again.
 */
@Component({
  selector: "app-task-tags",
  imports: [GpdPillComponent],
  template: `
    @for (tag of visible; track tag.id) {
      <gpd-pill [text]="tag.name" backgroundColor="#A7C687" color="#31451C" [maxWidth]="pillMaxWidth" [attr.title]="tag.name"></gpd-pill>
    }
    @if (hiddenCount > 0) {
      <button type="button" class="task-tags-toggle" [attr.aria-expanded]="expanded" (click)="toggle($event)">
        @if (expanded) {
          <ng-container i18n="@@showLess">show less</ng-container>
        } @else {
          +{{ hiddenCount }}
        }
      </button>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 6px;
        min-width: 0;
      }
      .task-tags-toggle {
        padding: 0 2px;
        border: none;
        background: none;
        font: inherit;
        font-size: 14px;
        color: var(--color-primary);
        cursor: pointer;
      }
      .task-tags-toggle:hover {
        color: var(--color-hover);
        text-decoration: underline;
      }
    `,
  ],
})
export class TaskTagsComponent {
  @Input() tags: TaskTag[] | null | undefined = [];
  /** Pills shown before collapsing into "+N"; 0 shows all. */
  @Input() max = 2;
  @Input() pillMaxWidth = "140px";

  expanded = false;

  get visible(): TaskTag[] {
    const tags = this.tags ?? [];
    return this.expanded || this.max <= 0 ? tags : tags.slice(0, this.max);
  }

  get hiddenCount(): number {
    return this.max > 0 ? Math.max((this.tags ?? []).length - this.max, 0) : 0;
  }

  toggle(event: Event) {
    // Don't let the click reach the grid row (row click selects/opens the task).
    event.stopPropagation();
    this.expanded = !this.expanded;
  }
}
